module.exports = __webpack_public_path__ + "img/fh.06026ecc.png";